import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { bulkSetSignupDataSkip } from '../../store/signup-data/action-creators';
import { Data } from '../../signup-data/DATA';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getCurrentStep } from '../../store/flow/selectors';
import { getIsNewPortalCreated } from '../../store/app/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { isSignupDataCompleted } from '../../store/signup-data/selectors';
import { Step } from '../../views/Step';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
export const BranchBIAB004 = {
  name: 'BranchBIAB004',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.BIAB004) && getIsNewPortalCreated(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.pushNextSteps(Step.BusinessBox));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};
const SurveySteps = [Step.CrmExperienceLevel, Step.HubInterest];
export const BranchBusinessBox = {
  name: 'BranchBusinessBox',
  stateCheck: state => {
    return isSignupDataCompleted(state, Data.BusinessBox) && getCurrentStep(state) === Step.BusinessBox;
  },
  rebuildFlow: (flow, _state, dispatch) => {
    dispatch(bulkSetSignupDataSkip({
      [Data.CrmExperienceLevel]: CrmExperienceOption.None,
      [Data.HubInterest]: HubInterestOption.Marketing,
      [Data.JobField]: JobFieldOption.Marketing
    }));
    return dispatch(FlowStateManager.removeSteps(...SurveySteps));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};